import * as toGeoJSON from "@tmcw/togeojson";

/**
 * Parses GPX file content into route points ([lat, lng] pairs).
 * Joins every track/route line in the file; falls back to waypoints when there are no lines.
 */
export const parseGpxRoute = (content) => {
  const xml = new DOMParser().parseFromString(content, "application/xml");
  const features = toGeoJSON.gpx(xml)?.features || [];

  const lines = features.flatMap(feature => {
    const geometry = feature?.geometry;
    if (geometry?.type === 'LineString') return [geometry.coordinates];
    if (geometry?.type === 'MultiLineString') return geometry.coordinates;
    return [];
  });
  const coordinates = lines.length
    ? lines.flat()
    : features
      .filter(feature => feature?.geometry?.type === 'Point')
      .map(feature => feature.geometry.coordinates);

  return coordinates
    .map(([lng, lat]) => [Number(lat), Number(lng)])
    .filter(([lat, lng]) => Number.isFinite(lat) && Number.isFinite(lng));
};
